import { uuidv7 } from 'uuidv7';

/**
 * Generates a UUIDv7 for use in the application.
 * UUIDv7 is preferred over standard UUIDs as they are time-sortable.
 * 
 * @returns A string containing a UUIDv7
 */
export const generateUuidV7 = (): string => {
  return uuidv7();
};

/**
 * Checks if a string is a valid UUID
 * 
 * @param id The string to check
 * @returns True if the string is a valid UUID
 */
export const isValidUUID = (id: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(id);
}; 